import React, { useEffect, useRef, useState } from "react";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button } from "primereact/button";
import Toolbar from "../../componentes/toolbar/Toolbar";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { Toast } from "primereact/toast";
import { useDispatch } from "react-redux";
import EntidadConstitución from "./Entidad";
import { useLocation, useNavigate } from "react-router-dom";
import {
  obtenerPaises,
  obtenerProvincias,
  obtenerTiposIdentificacion,
  obtenerTiposVisa,
} from "../../sliceRedux/Reserva.slice";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { enviarReserva, obtenerPeriodos } from "../../sliceRedux/ValidarReserva.slice";
import Socios from "./Socios";
import Directiva from "./Directiva.js";
import RegistrarOficial from "./RegistrarOficial.js";
import PreviewPDF from "../../componentes/PreviewPDF.js";

const Registro = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { datos, codSolReservaDenominacion, codSolConstitucion } = location.state || {};
  const stepperRef = useRef(null);
  const toast = useRef(null);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [constitucion, setConstitucion] = useState({});

  useEffect(() => {
    showLoader();
    Promise.all([
      dispatch(obtenerPeriodos()),
      dispatch(obtenerPaises()),
      dispatch(obtenerProvincias()),
      dispatch(obtenerTiposIdentificacion()),
      dispatch(obtenerTiposVisa()),
    ]).then(() => {
      hideLoader();
    });
  }, []);

  const enviarDatosReserva = () => {
    showLoader();
    const data = {
      codSolicitudConstitucion: constitucion?.codSolConstitucion ?? codSolConstitucion,
      codSolicitudReserva: codSolReservaDenominacion,
      codGrupoAde: constitucion?.codGrupoConstAdec ?? null,
    };
    dispatch(enviarReserva(data));
  };
  return (
    <>
      {loader}
      <Toast ref={toast} />
      <div className="card">
        <Toolbar>
          <React.Fragment>
            <Button
              label="Cancelar"
              icon="pi pi-times-circle"
              type="button"
              severity="info"
              onClick={(e) => {
                navigate("/solicitudes-constitucion", { state: { ...location.state } });
              }}
            />
          </React.Fragment>
        </Toolbar>
        <div className="text-center">
          <p className="font-semibold">
            Solicitud de{" "}
            {constitucion?.nomCatTipoSolicitud
              ? constitucion.nomCatTipoSolicitud
              : datos?.tipoSolicitud}
          </p>
        </div>
        <Stepper
          className="stepperConstitucion"
          ref={stepperRef}
          linear
          style={{ flexBasis: "50rem" }}
        >
          <StepperPanel header="Entidad">
            {stepperRef?.current && (
              <EntidadConstitución
                showLoader={showLoader}
                hideLoader={hideLoader}
                dispatch={dispatch}
                toast={toast}
                stepperRef={stepperRef}
                datos={datos}
                codSolReservaDenominacion={codSolReservaDenominacion}
                codSolConstitucion={constitucion?.codSolConstitucion ?? codSolConstitucion}
                setConstitucion={setConstitucion}
                nemTipoSolicitud={datos?.tipo ?? ""}
              />
            )}
          </StepperPanel>
          <StepperPanel header="Socios">
            <Socios
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              stepperRef={stepperRef}
              toast={toast}
              codSolConstitucion={constitucion?.codSolConstitucion ?? codSolConstitucion}
              reserva={constitucion?.solicitudReserva ?? {}}
              fecReunionAsamblea={constitucion?.fecReunionAsamblea ?? null}
              codGrupoConstAdec={constitucion?.codGrupoConstAdec ?? null}
              numSocios={constitucion?.numSocios ?? 0}
              nemEstado={constitucion?.nemCatEstadoSolicitud ?? ""}
              nemTipoSolicitud={datos?.tipo ?? ""}
            />
          </StepperPanel>
          <StepperPanel header="Directiva">
            <Directiva
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              stepperRef={stepperRef}
              toast={toast}
              codSolConstitucion={constitucion?.codSolConstitucion ?? codSolConstitucion}
              codGrupoConstAdec={constitucion?.codGrupoConstAdec ?? null}
              nemEstado={constitucion?.nemCatEstadoSolicitud ?? ""}
            />
          </StepperPanel>
          <StepperPanel header="Oficial de cumplimiento">
            <RegistrarOficial
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              stepperRef={stepperRef}
              toast={toast}
              codSolConstitucion={constitucion?.codSolConstitucion ?? codSolConstitucion}
              fecReunionAsamblea={constitucion?.fecReunionAsamblea ?? null}
              nemEstado={constitucion?.nemCatEstadoSolicitud ?? ""}
            />
          </StepperPanel>
          <StepperPanel header="Finalizar">
            <PreviewPDF
              showLoader={showLoader}
              hideLoader={hideLoader}
              toast={toast}
              dispatch={dispatch}
              navigate={navigate}
              codSolReservaDenominacion={codSolReservaDenominacion}
              codSolConstitucion={constitucion?.codSolConstitucion ?? codSolConstitucion}
              codGrupoConstAdec={constitucion?.codGrupoConstAdec ?? null}
              nemEstado={constitucion?.nemCatEstadoSolicitud ?? ""}
            />
            <div className="flex flex-column h-12rem">
              <div className="flex pt-4 justify-content-center">
                <Button
                  label="Enviar"
                  type="button"
                  severity="success"
                  icon="pi pi-send"
                  iconPos="right"
                  onClick={(e) => {
                    confirmDialog({
                      message: "¿Está seguro de enviar la solicitud de constitución?",
                      header: "Confirmación",
                      icon: "pi pi-exclamation-triangle",
                      acceptLabel: "Si",
                      icon: null,
                      rejectLabel: "No",
                      rejectIcon: "pi pi-times",
                      acceptIcon: "pi pi-check",
                      rejectClassName: "p-button-secondary",
                      accept: () => enviarDatosReserva(),
                      reject: () => null,
                    });
                  }}
                />
              </div>
            </div>
            <div className="flex pt-4 justify-content-end">
              <Button
                label="Anterior"
                severity="secondary"
                type="button"
                icon="pi pi-arrow-left"
                className="mr-2"
                onClick={() => stepperRef.current.prevCallback()}
              />
            </div>
          </StepperPanel>
        </Stepper>
      </div>
      <ConfirmDialog />
    </>
  );
};
export default Registro;
